import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {SecureHttp} from '../../@core/secure-http-client';
import {SessionService} from '../../@core/session.service';
import {FormsModule} from '@angular/forms';
import {NzInputDirective} from 'ng-zorro-antd/input';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzQRCodeComponent} from 'ng-zorro-antd/qr-code';

@Component({
  selector: 'app-impersonate',
  template: `
    @if (token()) {
      <div style="display: flex; margin-top: 20px; justify-content: center">
        <nz-qrcode (click)="signIn()" nzLevel="L" [nzPadding]="12" nzSize="256" [nzValue]="url()"></nz-qrcode>
      </div>
      <a style="margin:20px;" href="{{url()}}">Link</a>
    } @else {
      <div style="display: flex">
        <input nz-input [(ngModel)]="eid"/>
        <button nz-button (click)="impersonate()">Generate</button>
      </div>
    }
  `,
  styles: [],
  imports: [FormsModule, NzInputDirective, NzButtonComponent, NzQRCodeComponent]
})
export class ImpersonateComponent implements OnInit {

  eid = '';
  http = inject(SecureHttp);
  sess = inject(SessionService);
  token = signal(null);
  url = computed(() => {
    const t = this.token();
    return !t ? null : `${window.location.origin}/login/${t}`;
  });

  constructor() {
  }

  async ngOnInit(): Promise<void> {
  }

  async impersonate() {
    const result: any = await firstValueFrom(this.http.get(`/python-fns/ords/impersonate/${this.eid}`));
    this.token.set(`${result.access_token}`);
  }

  async signIn() {
    await this.sess.impersonate(this.token());
  }

}
